<template>
  <div>
    <v-layout wrap>
      <v-flex >
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            model="searchForm"
            key-property="accountId"
            search-url="/babiAccountClass/searchAll"
            create-url="/babiAccountClass/save"
            delete-url="/babiAccountClass/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            custom-class-item
            @classItem="openClassDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
            :acceptView="true"
            :accept-edit="true"
            :babiAcceptLogModeClass = "true"
            @viewItem="viewItem"
            :acceptExport="1"
            :accept-back="7"
        >
        </c-search-form>
        <material-type-group-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :hiddenFields="hiddenFields"
        />
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/admin/babi_account_class/AccountClassCreate";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: "BabiClass Danh sách học sinh",
      formCreateName: "BabiClass Thêm mới học sinh",
      className: null,
      category: null,
      visibleCreateDialog: false,
      timeReload: 0,
      searchUrl:null,
      accountId:null,
      allAcount: 0,
      hiddenFields: {
        typeId: "0",
      },
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          sortable: false,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'accountId',
          text: 'AccountID',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 70px;",
        },
        {
          value: 'phoneNumber',
          text: 'Phone',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 70px;",
        },
        {
          value: 'classId',
          text: 'Tên lớp',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 250px;",
          type: "select",
          name: "classId",
          items: [],
          itemText: "className",
          itemValue: "classId",
        },
        {
          value: 'programId',
          text: 'Khung chương trình',
          sortable: false,
          search: true,
          type: "select",
          name: "programId",
          items: [],
          itemText: "programName",
          itemValue: "programId",
          headerStyle: "text-align:center; width: 100px;",
        },
        {
          value: 'accountName',
          text: 'Họ tên',
          sortable: false,
          search: true,
          width: "9%",
          headerStyle: "text-align:center; width: 180px;",
        },
        {
          value: 'birthYear',
          text: 'Năm sinh',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'zaloPH',
          text: 'Zalo phụ huynh',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 150px;",
        },
        {
          value: 'classCurrentUnit',
          text: 'Unit chuẩn',
          search: true,
          sortable: false,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'classCurrentLevel',
          text: 'Level chuẩn',
          search: true,
          sortable: false,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'unitCurrent',
          text: 'Unit hiện tại',
          search: true,
          sortable: false,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'levelCurrent',
          text: 'Level hiện tại',
          search: true,
          sortable: true,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'unitDeviate',
          text: 'Unit lệch',
          search: true,
          sortable: true,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'missionNumber',
          text: 'Số nhiệm vụ đã làm',
          search: true,
          sortable: false,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'liveclassNumber',
          text: 'Live class',
          search: true,
          sortable: false,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'categoryNumber',
          text: 'Category',
          search: true,
          sortable: false,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'middleTest',
          text: 'Midterm test',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'finalTest',
          text: 'Final test',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'finalDate',
          text: 'Ngày hoàn thành final Test',
          type: "date",
          sortable: true,
          search: true,
          dateFormat: 'dd/MM/yyyy',
          headerStyle: "text-align:center",
          fromDate: "fromDate",
          toDate: "toDate"
        },
        {
          value: 'startDate',
          text: 'Ngày bắt đầu đăng ký ',
          type: "date",
          sortable: true,
          search: true,
          dateFormat: 'dd/MM/yyyy',
          headerStyle: "text-align:center",
          fromDate: "fromDate1",
          toDate: "toDate1"
        },
        {
          value: 'endDate',
          text: 'Ngày hết hạn đăng ký',
          type: "date",
          sortable: true,
          search: true,
          dateFormat: 'dd/MM/yyyy',
          headerStyle: "text-align:center",
          fromDate: "fromDate2",
          toDate: "toDate2"
        },
        {
          value: 'datePartPointInfoLog',
          text: 'Ngày vào học gần nhất',
          type: "date",
          sortable: true,
          search: true,
          dateFormat: 'dd/MM/yyyy',
          headerStyle: "text-align:center",
          fromDate: "fromDate3",
          toDate: "toDate3"
        },
        {
          value: 'listeningPoint',
          text: 'Điểm trung bình nghe Tuần - Current Week',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'speakingPoint',
          text: 'Điểm trung bình nói Tuần - Current Week',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'readingPoint',
          text: 'Điểm trung bình đọc Tuần - Current Week',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'writingPoint',
          text: 'Điểm trung bình viết Tuần - Current Week',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'bchtLink',
          text: 'Link BCHT Tuần',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'bchtMonthLink',
          text: 'Link BCHT Tháng',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'bchtMidTerm',
          text: 'Link BCHT Mid-Term',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'bchtFinal',
          text: 'Link BCHT Final Test',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'lessonNeedLearnToday',
          text: 'Bài học cần học trong ngày đó',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 50px;",
        },

        {
          value: 'lessonLearnedCount',
          text: 'Số lượng bài học đã học',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 50px;",
        },

        {
          value: 'lessonNeedLearnCount',
          text: 'Tổng số lượng bài phải học tính tới ngày đó',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 50px;",
        },

        {
          value: 'lessonLearnedLast',
          text: 'Bài học cuối',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 50px;",
        },

        {
          type: "select",
          name: "isCheckModeClass",
          value: 'isCheckModeClass',
          text: 'Chuyển lớp',
          sortable: false,
          search: true,
          headerStyle: "text-align:center ;width: 130px;",
          itemText: "status",
          itemValue: "value",
          items: [
            {value: 0, status: 'Chưa chuyển lớp'},
            {value: 1, status: 'Đã chuyển lớp'}
          ],
        },
/*        {
          value: 'isCheckModeClass',
          text: 'Chuyển lớp',
          sortable: false,
          search: true,
          headerStyle: "text-align:center; width: 50px;",
        },*/
        {
          value: "action",
          text: "lang.common.actions",
          sortable: false,
          compound: true,
          headerStyle: "text-align:center; width: 200px;",
        },
      ],
    };
  },

  created() {
    axios.post(
        process.env.VUE_APP_API_URL + "/babiClass/listAllName", {status: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "classId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );

    axios.post(
        process.env.VUE_APP_API_URL + "/babiProgram/listAllName", {status: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "programId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );
  },



  methods: {
    clearFromDate() {
      this.hiddenFields.fromDate = null;
    },
    clearToDate() {
      this.hiddenFields.toDate = null;
    },
    onChangeFromDate(date) {
      this.hiddenFields.fromDate = date;
    },
    onChangeToDate(date) {
      this.hiddenFields.toDate = date;
    },
    openCreateDialog: function (item = null) {
      if (item == null) {
        this.formCreateName = 'Thêm mới học sinh';
      } else {
        this.category = item;
        this.formCreateName = 'Cập nhật học sinh';
        this.visibleCreateDialog = true;
      }
    },
    openClassDialog: function (item = null) {
        this.category = item;
        this.formCreateName = 'Chuyển lớp';
        this.visibleCreateDialog = true;
    },
    closeCreateDialog: function () {
      this.category = null;
      this.visibleCreateDialog = false;
      this.timeReload = Math.floor(Math.random() * 100);
    },


    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      /*const obj2 = this.$route.query;*/
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
    viewItem: function (item) {
      this.$router.push({
        path: '/babiAccountDetail/view/' + item.accountId,
        //path: '/accountDetail/view/' + item.accountId,
        query: this.createParamLastSearch(this.lastSearchValues)
      });
    },
  },

  destroyed() {
  },
};
</script>
